import React from "react";
import PropTypes from "prop-types";

const OIntroductionCard = ({ content, gradientFrom, gradientTo }) => {
    const gradientStyle = {
        backgroundImage: `linear-gradient(to bottom, ${gradientFrom}, ${gradientTo}`,
        backgroundColor: `${gradientFrom}`
    };
    return (
        <div className="wch-sp relative min-vh-100">
            <header className="relative flex fira flex-column justify-center items-center min-vh-100 z-1">
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </header>
            <div style={gradientStyle} className={`absolute absolute--fill wch-t z0`} />
        </div>
    );
};

export default OIntroductionCard;

OIntroductionCard.propTypes = {
    content: PropTypes.string,
    gradientFrom: PropTypes.string,
    gradientTo: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/OIntroductionCard.js